module.exports = __webpack_public_path__ + "img/01-lg.8ca0129.webp";